import { ACHIEVEMENT_IDS } from "../types";
import type { AchievementId, Client, Grade, SaveGame } from "../types";

const TRUSTED_PARTNER_THRESHOLD = 81;
const LEVEL_5_THRESHOLD = 5;
const FLAWLESS_REPORT_SCORE = 100;

export interface AchievementCheckInput {
  save: SaveGame;
  clients: readonly Client[];
  lastGrade?: Grade;
  lastReportScore?: number;
}

/**
 * Returns achievements newly earned by this input: condition satisfied and not
 * already present in save.player.achievements. The result is ordered
 * canonically by ACHIEVEMENT_IDS.
 */
export function checkAchievements(input: AchievementCheckInput): AchievementId[] {
  const { save, clients, lastGrade, lastReportScore } = input;
  const earned = new Set<AchievementId>(save.player.achievements);

  const conditions: Readonly<Record<AchievementId, boolean>> = {
    first_contract: save.player.completedContracts.length >= 1,
    first_s_grade: lastGrade === "S",
    first_tool: save.player.ownedTools.length >= 1,
    trusted_partner: Object.values(save.clientTrust).some(
      (trust) => trust >= TRUSTED_PARTNER_THRESHOLD,
    ),
    all_clients_unlocked: clients.every((client) =>
      save.unlockedClients.includes(client.id),
    ),
    level_5: save.player.level >= LEVEL_5_THRESHOLD,
    flawless_report: lastReportScore === FLAWLESS_REPORT_SCORE,
  };

  return [...ACHIEVEMENT_IDS].filter((id) => conditions[id] && !earned.has(id));
}
